module.exports = __webpack_public_path__ + "img/pug_bg.2f901213.jpg";